import {collection} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {SellableReportSelectionData} from "../../../catalogue/sellable/controls/sellable-report-selection-control.component";

export class ExtraSalesSummaryReportData extends ReportData<ExtraSalesSummaryReportData> {
    @collection() groupBy: string[] = ["none"];
    @collection(SellableReportSelectionData) sellables: SellableReportSelectionData[];
}
